import React from 'react';

// Animated Solidcore Venture mark - loops the "attention → customer" story
// The SVG has all animations built-in via SMIL (animateMotion, animate)
export const AnimatedMark = ({ size = 34, idPrefix = 'nav' }) => {
  const tile = `${idPrefix}-tile`;
  const shine = `${idPrefix}-shine`;
  const spark = `${idPrefix}-spark`;
  const clip = `${idPrefix}-clip`;
  const route = `${idPrefix}-route`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      style={{ borderRadius: 10, boxShadow: '0 6px 20px -6px rgba(233,180,76,0.6)' }}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={tile} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F3C766" />
          <stop offset="1" stopColor="#C9892A" />
        </linearGradient>
        <linearGradient id={shine} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".35" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <radialGradient id={spark}>
          <stop offset="0" stopColor="#FFF7E3" />
          <stop offset=".45" stopColor="#FFE3A3" />
          <stop offset="1" stopColor="#FFE3A3" stopOpacity="0" />
        </radialGradient>
        <clipPath id={clip}>
          <rect width="64" height="64" rx="16" />
        </clipPath>
      </defs>

      <rect width="64" height="64" rx="16" fill={`url(#${tile})`} />

      <g clipPath={`url(#${clip})`}>
        <rect y="-20" width="18" height="104" fill={`url(#${shine})`} transform="rotate(20 32 32)" opacity="0">
          <animate attributeName="x" dur="4s" repeatCount="indefinite" values="-40;-40;80;80" keyTimes="0;0.37;0.6;1" />
          <animate attributeName="opacity" dur="4s" repeatCount="indefinite" values="0;0;1;1;0;0" keyTimes="0;0.37;0.38;0.59;0.6;1" />
        </rect>
      </g>

      <path
        id={route}
        d="M42 17.5H26.5a7.25 7.25 0 0 0 0 14.5h11a7.25 7.25 0 0 1 0 14.5H23"
        pathLength="100"
        fill="none"
        stroke="#1C1405"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="100 100"
        strokeDashoffset="100"
      >
        <animate
          attributeName="stroke-dashoffset"
          dur="4s"
          repeatCount="indefinite"
          calcMode="spline"
          values="100;100;0;0;-100;-100"
          keyTimes="0;0.04;0.37;0.76;0.94;1"
          keySplines="0 0 1 1;.6 0 .25 1;0 0 1 1;.6 0 .4 1;0 0 1 1"
        />
      </path>

      <circle cx="45.5" cy="17.5" r="0" fill="#F3C766" stroke="#1C1405" strokeWidth="3">
        <animate
          attributeName="r"
          dur="4s"
          repeatCount="indefinite"
          calcMode="spline"
          values="0;5.6;4.6;4.6;0;0"
          keyTimes="0;0.035;0.07;0.8;0.9;1"
          keySplines=".3 0 .3 1;.3 0 .3 1;0 0 1 1;.6 0 .4 1;0 0 1 1"
        />
      </circle>

      <circle r="4.2" fill={`url(#${spark})`} opacity="0">
        <animateMotion
          dur="4s"
          repeatCount="indefinite"
          calcMode="spline"
          keyPoints="0;0;1;1"
          keyTimes="0;0.04;0.37;1"
          keySplines="0 0 1 1;.6 0 .25 1;0 0 1 1"
        >
          <mpath href={`#${route}`} />
        </animateMotion>
        <animate
          attributeName="opacity"
          dur="4s"
          repeatCount="indefinite"
          values="0;0;1;1;0;0"
          keyTimes="0;0.04;0.06;0.35;0.38;1"
        />
      </circle>

      <circle cx="19" cy="46.5" r="6.2" fill="none" stroke="#1C1405" strokeWidth="1.6" opacity="0">
        <animate attributeName="r" dur="4s" repeatCount="indefinite" values="6.2;6.2;15;15" keyTimes="0;0.38;0.6;1" />
        <animate attributeName="opacity" dur="4s" repeatCount="indefinite" values="0;0;.55;0;0" keyTimes="0;0.379;0.38;0.6;1" />
      </circle>

      <circle cx="19" cy="46.5" r="0" fill="#1C1405">
        <animate
          attributeName="r"
          dur="4s"
          repeatCount="indefinite"
          calcMode="spline"
          values="0;0;7.6;6.2;6.2;0;0"
          keyTimes="0;0.36;0.41;0.46;0.86;0.95;1"
          keySplines="0 0 1 1;.3 0 .3 1;.3 0 .3 1;0 0 1 1;.6 0 .4 1;0 0 1 1"
        />
      </circle>
    </svg>
  );
};

export default AnimatedMark;
